@import "tailwindcss";
@import "@xyflow/react/dist/style.css";

@theme {
  --color-bg: #1a1c20;
  --color-bg-2: #232629;
  --color-bg-3: #2d3035;
  --color-line: #3a3d42;
  --color-text: #d8d8d8;
  --color-dim: #a8acb1;
  --color-accent: #d8a23a;
  --color-accent-2: #f4d03f;
  --color-danger: #e87878;
  --font-mono: "IBM Plex Mono", ui-monospace, Menlo, Consolas, monospace;
}

@layer base {
  html,
  body,
  #root {
    height: 100%;
  }
  body {
    margin: 0;
    color-scheme: dark;
    background: var(--color-bg);
    color: var(--color-text);
    font-family: var(--font-mono);
    font-size: 12px;
  }
}
